import React, { memo } from "react";
import { TableCell, TableHead, TableRow } from "@material-ui/core";
import { useHeadStyles } from "./styles";

function TableHeadCustom({
  columns,
  removeHeaderBackground,
  hideBorderBottom = false
}) {

  const classes = useHeadStyles();
  function renderCell(title = '', col) {    
    if (col.headerRender) {
      return col.headerRender(title);
    } else {
      return title;
    }
  }  
  return (
    <TableHead>
      <TableRow className={removeHeaderBackground ? classes.transparentHead : null}>
        {columns.map((c) => (
          <TableCell
            key={c.key}
            align={c.headerAlign ?? (c.align || "left")}
            width={c.maxWidth ?? 'auto'}
            style={{ minWidth: c.width || "auto", maxWidth: c.maxWidth || "auto", fontSize: 12,
            borderBottom: hideBorderBottom ? 'none' : '1px solid lightgray', }}
          >
            {renderCell(c.title, c)}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default memo(TableHeadCustom);
